(function ($, Drupal) {

  Drupal.behaviors.header_search_init = {
    attach() {
      $(document).ready(function () {

        const trigger_selector = $('#block-wingsuit-search');

        trigger_selector.on("click", function (event) {
          event.stopImmediatePropagation();

          $('.header').toggleClass('search-open');
        });

      });
    },
  };

  Drupal.behaviors.header_search_results_truncate = {
    attach() {
      $(document).ready(function () {

        $(".search-result-item-desc span").each(function() {

          var originalText = $(this).text().replace(/\s+/g, ' ');

          if (originalText.length > 300) {
            originalText = originalText.substring(0, 300) + '...';
          }

          $(this).text(originalText);
        });

      });
    },
  };


}(jQuery, Drupal));
